import React, { type SVGProps } from 'react';

const Lists = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 24 24"
    width="70"
    height="70"
  >
    <path
      d="M6.09 15.91a1.94 1.94 0 00-1.42-.58c-1.1 0-2 .9-2 2s.9 2 2 2c1.1.01 2.01-.88 2.01-1.99.01-.54-.21-1.05-.59-1.43zm0-5.33A1.94 1.94 0 004.67 10a2 2 0 00-1.42 3.41c.37.38.89.6 1.42.59 1.1.01 2.01-.88 2.01-1.99.01-.54-.21-1.05-.59-1.43zm15.14 5.52A.326.326 0 0021 16H8.34c-.18.01-.32.15-.33.33v2c.01.18.15.32.33.33H21c.18-.01.32-.15.33-.33v-2c0-.09-.04-.17-.1-.23zM6.09 5.25a1.94 1.94 0 00-1.42-.58c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c.01-.53-.2-1.05-.58-1.42zm15.14 5.51a.326.326 0 00-.23-.1H8.34c-.19 0-.34.15-.34.34v2c.01.18.15.32.33.33H21c.18-.01.32-.15.33-.33v-2c0-.09-.04-.17-.1-.23v-.01zm0-5.33a.317.317 0 00-.23-.09H8.34c-.18 0-.33.15-.34.33v2c.01.18.16.33.34.33H21c.18-.01.32-.15.33-.33v-2c0-.09-.04-.17-.1-.24z"
      vectorEffect="non-scaling-stroke"
      fill="currentColor"
    />
  </svg>
);

export default Lists;
